module.exports = __webpack_public_path__ + "img/Z60Q_08.899b42ce.jpg";